import { useMany } from '@refinedev/core';
import { keepPreviousData } from '@tanstack/react-query';
import type { CollectionOut } from '@/api/generated/schemas';

export interface LineupCollectionLookups {
  collectionById: Map<number, CollectionOut>;
  /** While true a missing collection means "not fetched yet", not "gone". */
  isLoading: boolean;
}

/** Collections behind a set of lineup rows. Ids are sorted and deduped: they
 * are part of the query key, so row order would refetch on every drag. */
export const useLineupCollections = (
  collectionIds: number[]
): LineupCollectionLookups => {
  const fetchIds = [...new Set(collectionIds)].sort((a, b) => a - b);
  const { result, query } = useMany<CollectionOut>({
    resource: 'user_catalog.collections',
    ids: fetchIds,
    // Ids are the query key, so adding or removing a row starts a new
    // query — without this the rows blank out until it lands.
    queryOptions: {
      enabled: fetchIds.length > 0,
      placeholderData: keepPreviousData,
    },
  });

  return {
    collectionById: new Map(result?.data.map((c) => [c.id, c])),
    isLoading: query.isFetching,
  };
};
